module.exports = __webpack_public_path__ + "img/6261101_orig.848666a3.jpg";